/**
 * @description Link 是否需要登入 (enum)
 */
export enum LinkAuthenticationEnum {
  /** 不需要 */
  NotRequired = '0',
  /** 需要 */
  Required = '1'
}
